module.exports = __webpack_public_path__ + "b8009156117f730275d7df3fc52d96e0.png";